/* S3-manual's value, owned by S3 (which holds the dock and the lookup). */
import type { Airline } from '../../lib/api';

export interface ManualValue {
  airline: Airline | null;
  /** What the airline input shows (typing clears `airline`). */
  airlineText: string;
  /** 1–4 digits. */
  number: string;
}

export const EMPTY_MANUAL: ManualValue = { airline: null, airlineText: '', number: '' };
